export default "__VITE_ASSET__DJFzpxau__"